import React, { useEffect } from "react";
import { MDBAnimation, MDBCarousel, MDBCarouselCaption, MDBCarouselInner, MDBCarouselItem, MDBView, MDBMask, MDBContainer, MDBRow } from
    "mdbreact";
import { IMGBgMuba } from "src/assets";
import { setFormSearchDatas } from 'src/config/redux/action';
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from 'react-router';

const CarouselHome = () => {
    const history = useHistory();
    const { formSearchDatas } = useSelector(state => state.dataReducer);
    const {
        SearchText
    } = formSearchDatas;
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(setFormSearchDatas('SearchText', ''))
    }, [dispatch])
    const handleKeyDownSearch = (event) => {
        if (event.key === 'Enter') {
            history.push(`/data`)
        }
    }
    return (
        <>

            <MDBContainer fluid>
                <MDBRow>
                    <MDBCarousel
                        activeItem={1}
                        length={1}
                        showControls={false}
                        showIndicators={false}
                        id="Home_banner"
                    >
                        <MDBCarouselInner>
                            <MDBCarouselItem itemId="1">
                                <MDBView>
                                    <img className="d-block w-100" src={IMGBgMuba} alt="First slide" />
                                </MDBView>
                                <MDBCarouselCaption>
                                    <div className="container-xl">
                                        <div className="carousel-caption-inner banner3">
                                            <MDBAnimation className="slideInUp" count={1} delay="2s" >
                                                <h2><div className="text-warning">PORTAL</div> SATUDATA KABUPATEN MUSI BANYUASIN</h2>
                                            </MDBAnimation>
                                            <MDBAnimation className="slideInUp" count={1} delay="2.5s" >
                                                <p className="text">Integrasi Satu Data Wujudkan Pembangunan Berkelanjutan Menuju Muba Maju Berjaya.</p>
                                            </MDBAnimation>
                                            <MDBAnimation className="slideInUp" count={1} delay="3s" >
                                                <p>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        style={{ background: 'white', borderColor: '#0170C1' }}
                                                        placeholder="Cari Data, Organisasi, Kategori, Tag..."
                                                        onChange={(e) => dispatch(setFormSearchDatas('SearchText', e.target.value))}
                                                        value={SearchText}
                                                        onKeyDown={handleKeyDownSearch} 
                                                    />
                                                    <Link to={'/data'} className="mt-2 res-767-mt-2 ttm-btn ttm-btn-size-md ttm-btn-style-border ttm-btn-color-white ttm-textcolor-white">
                                                        <i className="fas fa-search" />Cari Data
                                                    </Link>
                                                </p>

                                            </MDBAnimation>
                                        </div>
                                    </div>
                                </MDBCarouselCaption>
                            </MDBCarouselItem>
                            <MDBCarouselItem itemId="2">
                                <MDBView>
                                    <img className="d-block w-100" src="https://mubakab.go.id/files/foto/kantor-bupati_20200228141932.jpeg" alt="Second slide" />
                                </MDBView>
                                <MDBCarouselCaption>
                                    <div className="container-xl">
                                        <div className="carousel-caption-inner banner4">
                                            <MDBAnimation className="slideInUp" count={1} delay="5s" >
                                                <h2>Say Goodbye to Bring Repetitive Legal Work </h2>
                                            </MDBAnimation>
                                            <MDBAnimation className="slideInUp" count={1} delay="5.5s" >
                                                <p className="text">We are equipped with an updated technical knowledge to serve our customers  properly. Our method of application maintains the industry.</p>
                                            </MDBAnimation>
                                            <MDBAnimation className="slideInUp" count={1} delay="6s" >
                                                <p className="mt-4">
                                                    <button className="ttm-btn ttm-btn-size-md ttm-bgcolor-skincolor mr-3">read more</button>
                                                    <button className="ttm-btn ttm-btn-size-md ttm-btn-style-border ttm-btn-color-white">get altech</button>
                                                </p>
                                            </MDBAnimation>
                                        </div>
                                    </div>
                                </MDBCarouselCaption>
                            </MDBCarouselItem>
                        </MDBCarouselInner>
                    </MDBCarousel>
                </MDBRow>
            </MDBContainer>
        </>
    );
}

export default CarouselHome;